module.exports = __webpack_public_path__ + "assets/img/RECEPCIONPENDIENTE.4deb5e84.svg";